<template>
	<div class="container-fluid">
		<div class="row">
			<div class="col-lg-8 mr-auto ml-auto col-md-10">
				<form class="form-horizontal" action="." method="post">
					<fieldset>
						<legend>{{ 'General information' | translate }}</legend>

						<div class="row form-group">
							<label class="col-md-3 offset-md-2">Email *</label>
							<div class="col-md-7">
								<input
									type="email"
									:class="emailError ? 'error' : ''"
									v-model="email"
									@change="checkEmail"
									class="form-control"
								/>
							</div>
							<label class="col-12 text-right text-danger" v-if="emailError">
								{{ emailError | translate }}
							</label>
						</div>
						<div class="row form-group">
							<label class="col-md-3 offset-md-2">
								{{ 'Phone number' | translate }} *
							</label>
							<div class="col-md-7">
								<input
									type="text"
									:class="numberError ? 'error' : ''"
									v-model="number"
									class="form-control"
								/>
							</div>
							<label class="col-12 text-right text-danger" v-if="numberError">
								{{ numberError }}
							</label>
						</div>
						<div class="row form-group">
							<label class="col-md-3 offset-md-2">
								{{ 'First name' | translate }} *
							</label>
							<div class="col-md-7">
								<input
									type="text"
									v-model="firstName"
									:class="{ error: firstNameError }"
									class="form-control"
								/>
							</div>
							<label
								class="col-12 text-right text-danger"
								v-if="firstNameError"
							>
								{{ firstNameError }}
							</label>
						</div>

						<!-- <div class="row form-group">
							<label class="col-md-3 offset-md-2">{{
								'Surname' | translate
							}}</label>
							<div class="col-md-7">
								<input type="text" v-model="middleName" class="form-control" />
							</div>
						</div> -->

						<div class="row form-group">
							<label class="col-md-3 offset-md-2">
								{{ 'Last name' | translate }} *
							</label>
							<div class="col-md-7">
								<input
									type="text"
									v-model="lastName"
									:class="{ error: lastNameError }"
									class="form-control"
								/>
							</div>
							<label class="col-12 text-right text-danger" v-if="lastNameError">
								{{ lastNameError }}
							</label>
						</div>
						<div class="row form-group">
							<label class="col-md-3 offset-md-2">
								{{ 'Date of birth' | translate }} *
							</label>
							<div class="col-md-7 date-group">
								<datepicker
									v-model="birthDay"
									:format="format"
									:class="{ error: birthDayError }"
									class="-control"
								></datepicker>
							</div>
							<label class="col-12 text-right text-danger" v-if="birthDayError">
								{{ birthDayError }}
							</label>
						</div>
						<div class="row form-group">
							<label class="col-md-3 offset-md-2">
								{{ 'Password' | translate }} *
							</label>
							<div class="col-md-7">
								<input
									type="text"
									:class="passwordError ? 'error' : ''"
									v-model="password"
									class="form-control"
								/>
							</div>
							<label class="col-12 text-right text-danger" v-if="passwordError">
								{{ passwordError }}
							</label>
						</div>
					</fieldset>
					<fieldset>
						<legend>{{ 'Parents' | translate }}</legend>
						<div class="row form-group">
							<label class="col-md-3 offset-md-2">
								{{ 'First name' | translate }}*
							</label>
							<div class="col-md-7">
								<input
									:class="parentNameError ? 'error' : ''"
									:disabled="!showParent"
									required
									v-model="parentFirstName"
									class="form-control"
								/>
							</div>
							<label
								class="col-12 text-right text-danger"
								v-if="parentNameError"
							>
								{{ parentNameError }}
							</label>
						</div>
						<!-- <div class="row form-group">
							<label class="col-md-3 offset-md-2">{{
								'Surname' | translate
							}}</label>
							<div class="col-md-7">
								<input type="text" :disabled="!showParent" v-model="parentMiddleName" class="form-control" />
							</div>
						</div> -->
						<div class="row form-group">
							<label class="col-md-3 offset-md-2">
								{{ 'Last name' | translate }}
							</label>
							<div class="col-md-7">
								<input
									type="text"
									:disabled="!showParent"
									v-model="parentLastName"
									class="form-control"
								/>
							</div>
						</div>
						<div v-if="showParent" class="row form-group">
							<label class="col-md-3 offset-md-2">
								{{ 'Password' | translate }} *
							</label>
							<div class="col-md-7">
								<input
									type="text"
									:class="passwordParentError ? 'error' : ''"
									v-model="parentPassword"
									class="form-control"
								/>
							</div>
							<label
								class="col-12 text-right text-danger"
								v-if="passwordParentError"
							>
								{{ passwordParentError }}
							</label>
						</div>
					</fieldset>
					<fieldset>
						<legend>{{ 'Additional information' | translate }}</legend>
						<!-- <div class="row form-group checkbox">
							<label class="offset-md-2">
								<input type="checkbox" v-model="isEmailSubscribed" />{{
									'With email newsletter' | translate
								}}
							</label>
						</div> -->
					</fieldset>
					<div class="row form-group">
						<label class="col-md-3 offset-md-2">
							{{ 'Language of instruction' | translate }} *
						</label>
						<div class="col-md-7">
							<select
								:class="{ error: languageError }"
								class="form-control"
								v-model="language"
							>
								<option value="UA">UA</option>
								<option value="RU">RU</option>
								<option value="AZ">AZ</option>
								<option value="PL">PL</option>
								<option value="HE">HE</option>
								<option value="HY">HY</option>
								<option value="RO">RO</option>
								<option value="EN">EN</option>
								<option value="FR">FR</option>
								<option value="ES">ES</option>
								<option value="CS">CZ</option>
								<option value="DE">DE</option>
								<option value="IT">IT</option>
								<option value="TR">TR</option>
								<option value="EL">EL</option>
							</select>
						</div>
						<label class="col-12 text-right text-danger" v-if="languageError">
							{{ languageError }}
						</label>
					</div>

					<div class="row form-group">
						<label class="col-md-3 offset-md-2">
							{{ 'First month cost' | translate }}
						</label>
						<div class="col-md-7">
							<input
								type="number"
								:class="priceForMonthError ? 'error' : ''"
								@change="changeEducationPriceEn"
								v-model="price_first_month"
								class="form-control"
							/>
						</div>
						<label
							class="col-12 text-right text-danger"
							v-if="priceForMonthError"
						>
							{{ priceForMonthError }}
						</label>
					</div>

					<div class="row form-group">
						<label class=" col-md-3 offset-md-2">
							{{ 'Сost of education' | translate }} *
						</label>
						<div class="col-md-7">
							<input
								:class="priceError ? 'error' : ''"
								type="number"
								@change="changeEducationPrice"
								v-model="education"
								class="form-control"
							/>
						</div>
						<label class="col-12 text-right text-danger" v-if="priceError">
							{{ priceError }}
						</label>
					</div>

					<!-- <fieldset class="form-group">
						<legend>{{ 'Paid status' | translate }} *</legend>
						<div class="form-check row">
							<label class="form-check-label col-md-3 offset-md-2">
								<input type="radio" class="form-check-input" name="optionsRadios" v-model="paidStatus" value="paid"
									checked />
								{{ 'Paid' | translate }}
							</label>
						</div>

						<div class="form-check row">
							<label class="form-check-label  col-md-3 offset-md-2">
								<input type="radio" class="form-check-input" name="optionsRadios" v-model="paidStatus" value="not-paid" />
								{{ 'Not paid' | translate }}
							</label>
						</div>

						<label class="col-12 text-right text-danger" v-if="paymentError">{{
							paymentError
						}}</label>
					</fieldset> -->

					<div class="row form-group">
						<label class="col-md-3 offset-md-2">
							{{ 'Comment' | translate }}
						</label>
						<div class="col-md-7">
							<textarea
								v-model="comments"
								class="form-control"
								rows="3"
							></textarea>
						</div>
					</div>
					<div class="text-right btn-create">
						<button
							@click.prevent="createProfile"
							:disabled="loading"
							class="btn btn-primary"
						>
							{{ 'Create' | translate }}
						</button>
					</div>
				</form>
			</div>
		</div>
	</div>
</template>

<script>
import Datepicker from 'vuejs-datepicker'

export default {
	name: 'Student-Parent',
	data() {
		return {
			loading: false,
			myRole: this.$store.state.myProfile.role,
			isEmailSubscribed: false,
			showEng: true,
			showParent: true,
			format: 'dd/MM/yyyy',
			birthDay: null,
			number: '',
			email: '',
			firstName: '',
			lastName: '',
			firstNameError: '',
			lastNameError: '',
			birthDayError: '',
			middleName: '',
			comments: '',
			parentLastName: '',
			parentFirstName: '',
			parentMiddleName: '',
			parentPassword: '',
			education: 0,
			minEducation: 0,
			royalty: 0,

			price_first_month: 0,

			minEducationEn: 0,
			royaltyEn: 0,
			language: '',
			paidStatus: '',
			teacherId: 0,
			password: '',
			emailError: '',
			numberError: '',
			passwordError: '',
			passwordParentError: '',
			detailError: '',
			languageError: '',
			paymentError: '',
			educationError: '',
			educationErrorEn: '',
			parentNameError: '',

			priceError: '',
			priceForMonthError: '',

			fatherId: 0,
		}
	},
	components: {
		Datepicker,
	},
	methods: {
		changeEducationPrice() {
			if (this.education < 0) {
				this.education = 0
				return true
			}
		},
		changeEducationPriceEn() {
			if (this.price_first_month < 0) {
				this.price_first_month = 0
				return true
			}
		},
		craeteStudent(parentId) {
			let birthday = null
			if (this.birthDay !== null) {
				birthday = this.birthDay.toISOString().slice(0, 10)
			}

			// let price = 0
			// let price_first_month = 0

			// price_first_month = Number(this.price_first_month)

			// price = Number(this.education)

			this.axios({
				method: 'post',
				url: 'users/user',
				data: {
					phone_number: this.number,
					email: this.email,
					first_name: this.firstName,
					middle_name: this.middleName,
					last_name: this.lastName,
					birthday: birthday,
					role: 'student',
					is_email_subscribed: this.isEmailSubscribed,
					comments: this.comments,
					group: this.$store.state.forGroup,
					password: this.password,
					parent: parentId,
					paid_status: this.paidStatus,
					default_language: this.language,

					price: Number(this.education) || 0,
					price_first_month: Number(this.price_first_month) || 0,
					// price_en: priceEn,
				},
			})
				.then(response => {
					this.loading = false
					this.$toast(this.$t('Changes saved'), {
						className: ['btn-success', 'notif'],
						duration: 3000,
					})
					this.$router.push({
						name: 'Dashboard List',
						params: { role: 'group' },
					})
				})
				.catch(error => {
					console.log('create student', error)

					this.loading = false
					if (error.response.data.phone_number) {
						this.numberError = this.$t(error.response.data.phone_number[0])
					}

					if (error.response.data.email) {
						this.emailError = this.$t(error.response.data.email[0])
					}

					if (error.response.data.detail) {
						this.detailError = this.$t(error.response.data.detail[0])
					}
				})
		},
		checkEmail() {
			this.parentFirstName = ''
			this.parentMiddleName = ''
			this.parentLastName = ''
			this.axios({
				method: 'post',
				url: 'users/user/check-email',
				data: {
					email: this.email,
				},
			}).then(response => {
				// console.log(response)

				if (response.data.id === null) {
					this.showParent = true

					this.emailError = ''
				} else {
					this.emailError = 'A student with this email address already exists'

					this.fatherId = response.data.id
					this.parentFirstName = response.data.first_name
					this.parentMiddleName = response.data.middle_name
					this.parentLastName = response.data.last_name
					this.showParent = false
					// this.$toast(this.$t('Parent found'), {
					// 	className: ['btn-success', 'notif'],
					// 	duration: 3000,
					// })
				}
			})
		},
		createProfile() {
			let error = false
			this.loading = true
			this.emailError = ''
			this.numberError = ''
			this.firstNameError = ''
			this.lastNameError = ''
			this.birthDayError = ''
			this.passwordError = ''
			this.passwordParentError = ''
			this.detailError = ''
			this.languageError = ''
			this.paymentError = ''
			this.educationError = ''
			this.educationErrorEm = ''
			this.parentNameError = ''

			if (this.email === '') {
				this.emailError = this.$t('Field required')
				error = true
			}

			if (this.number === '') {
				this.numberError = this.$t('Field required')
				error = true
			}

			if (!this.firstName.trim()) {
				this.firstNameError = this.$t('Field required')
				error = true
			}

			if (!this.lastName.trim()) {
				this.lastNameError = this.$t('Field required')
				error = true
			}

			if (!this.birthDay) {
				this.birthDayError = this.$t('Field required')
				error = true
			}

			if (this.language === '') {
				this.languageError = this.$t('Field required')
				error = true
			}

			if (this.education === '') {
				this.priceError = this.$t('Field required')
				error = true
			}

			if (this.price_first_month === '') {
				this.priceForMonthError = this.$t('Field required')
				error = true
			}

			// if (this.paidStatus === '') {
			// 	this.paymentError = this.$t('Field required')
			// 	error = true
			// }

			if (this.parentFirstName === '' && this.showParent) {
				this.parentNameError = this.$t('Field required')
				error = true
			}

			if (this.changeEducationPrice()) {
				error = true
			}

			if (this.changeEducationPriceEn()) {
				error = true
			}

			if (this.password === '') {
				this.passwordError = this.$t('Field required')
				error = true
			}

			if (this.parentPassword === '' && this.showParent) {
				this.passwordParentError = this.$t('Field required')
				error = true
			}

			if (this.password === this.parentPassword && this.password !== '') {
				this.passwordError = this.$t(
					'The passwords of the parent and the student should not coincide'
				)
				this.passwordParentError = this.$t(
					'The passwords of the parent and the student should not coincide'
				)
				error = true
			}

			if (error) {
				this.loading = false
				return false
			}

			if (this.showParent) {
				this.axios({
					method: 'post',
					url: 'users/user',
					data: {
						phone_number: this.number,
						email: this.email,
						first_name: this.parentFirstName,
						middle_name: this.parentMiddleName,
						last_name: this.parentLastName,
						role: 'parent',
						password: this.parentPassword,
						parent: this.teacherId,
					},
				})
					.then(data => {
						this.craeteStudent(data.data.id)
					})
					.catch(error => {
						this.loading = false
						if (error.response.data.phone_number) {
							this.numberError = this.$t(error.response.data.phone_number[0])
						}

						if (error.response.data.email) {
							this.emailError = this.$t(error.response.data.email[0])
						}

						if (error.response.data.detail) {
							this.detailError = this.$t(error.response.data.detail[0])
						}

						if (
							error.response.data.detail ==
							'User with this email already exists'
						) {
							this.emailError =
								'A student with this email address already exists'
						}

						console.log('Error', error.response)
					})
			} else {
				this.craeteStudent(this.fatherId)
			}
		},
	},
	beforeMount() {
		if (this.$store.state.forGroup === '') {
			this.$router.push({ name: 'Dashboard List', params: { role: 'group' } })
		} else {
			this.axios({
				method: 'get',
				url: `groups/${this.$store.state.forGroup}`,
			}).then(response => {
				if (
					response.data.teacher_royalty_en !== null &&
					response.data.teacher_royalty_en !== '' &&
					response.data.teacher_royalty_en !== 0
				) {
					this.showEng = true
					// this.educationEn = response.data.teacher_price_min_en
					this.minEducationEn = response.data.teacher_price_min_en
					this.royaltyEn = response.data.teacher_royalty_en
				}
				this.teacherId = response.data.teacher
				this.price_first_month = response.data.teacher_price_min
				this.education = response.data.teacher_price_min
				this.minEducation = response.data.teacher_price_min
				this.royalty = response.data.teacher_royalty
			})
		}
	},
	beforeDestroy() {
		this.$store.commit('changeForGroup', '')
	},
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
legend {
	text-align: center;

	margin: 30px 0;
}

.form-control,
input {
	border-color: #b7afbf;
	border-radius: 8px;
	padding: 8px;
}

.btn-create {
	margin: 30px 0;

	& button {
		padding: 10px 25px;
		border-radius: 12px;
		border-color: #fab610;
		background: #fab610 !important;
		color: #fff !important;
		font-family: Montserrat;
		font-size: 18px;
		font-style: normal;
		font-weight: 600;
	}
}

.dropdown.v-select.searchable {
	background-color: #fff;
}
</style>
